// Novedad de la sección Muestra médica.
//   variant="card" -> Momento 1: tarjeta grande debajo del selector (antes de
//                     elegir categoría). Usa image_card_url.
//   variant="pill" -> Momento 2: pastilla de ancho completo arriba del listado
//                     (con categoría elegida). Usa image_pill_url.
export function Novedad({ novedad, variant }) {
    if (!novedad) return null;

    if (variant === "pill") {
        return (
            <div className="novedad-pill">
                <div className="novedad-pill-icon">
                    <i className="fas fa-gift"></i>
                </div>
                <div className="novedad-pill-body">
                    <p className="novedad-pill-title">{novedad.main_text}</p>
                    {novedad.secondary_text &&
                        <p className="novedad-pill-subtitle">{novedad.secondary_text}</p>}
                </div>
                {novedad.image_pill_url &&
                    <div className="novedad-pill-img">
                        <img src={novedad.image_pill_url} alt="" />
                    </div>}
            </div>
        );
    }

    // variant "card" (Momento 1)
    return (
        <div className="ecard novedad-card">
            {novedad.image_card_url &&
                <div className="novedad-card-img">
                    <img src={novedad.image_card_url} alt="" />
                </div>}
            <div className="novedad-card-body">
                <div className="novedad-card-row novedad-card-row-title">
                    <p className="novedad-card-title">{novedad.main_text}</p>
                    <span className="novedad-badge">
                        <i className="fas fa-gift"></i> Regalo
                    </span>
                </div>
                {novedad.secondary_text &&
                    <p className="novedad-card-subtitle">{novedad.secondary_text}</p>}
                {novedad.badge_text &&
                    <div className="novedad-card-chip-row">
                        <span className="novedad-chip">
                            <i className="fas fa-star"></i> {novedad.badge_text}
                        </span>
                    </div>}
            </div>
        </div>
    );
}
